import application from 'application/application';

import template from './atendimento.template.html';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account.atendimento', {
				url: '/atendimento',
				views: {
					'default@root.default': {
						templateUrl: template
					}
				},
				data: {
					documentTitle: 'Atendimento'
				}
			});

	}]);
